import React from 'react';

const IconShare = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#19191A"
        strokeLinecap="round"
        d="M19.75 9.5v6.776a3.75 3.75 0 0 1-3.75 3.75H8a3.75 3.75 0 0 1-3.75-3.75V9.5m11-2.974-2.013-2.013a1.75 1.75 0 0 0-2.474 0L8.75 6.526m3.25.5v7"
      ></path>
    </svg>
  );
};

export default IconShare;
